import {Controller} from "stimulus"
import AutoNumeric from "autonumeric"
import Rails from "@rails/ujs";

export default class extends Controller {

    connect() {
        console.log("log from bl-license_applications controller");
        const applicationParcels = this.element.querySelector(".application-parcels");
        if (applicationParcels) {
            Array.from(applicationParcels.querySelectorAll(".delete-action")).map(action => {
                action.classList.remove("hidden");
            });
        }
    }

    removeParcel(e) {
        if (!confirm("Are you sure you want to remove this parcel?")) {
            return;
        }
        const parcelSummaryArea = this.element.querySelector(".application-parcels ul");
        const chosenParcel = e.currentTarget.closest("li");
        const assignmentKey = chosenParcel.dataset.assignmentKey;
        parcelSummaryArea.removeChild(chosenParcel);

        const parcelFieldList = this.element.querySelector(".selected-parcels .results-list");
        if (parcelFieldList && assignmentKey) {
            const assignment = parcelFieldList.querySelector(`li[data-assignment-key="${assignmentKey}"]`);
            if (assignment) {
                const destroyField = assignment.querySelector("input[name*='[_destroy]']");
                const parcelField = assignment.querySelector("input[name*='[parcel_id]']");
                if (parcelField) { parcelField.value = ""; }
                if (destroyField) { destroyField.value = "1"; }
            }
        }

        const resultsList = parcelFieldList || this.element.querySelector(".results-list");
        if (resultsList) {
            resultsList.dispatchEvent(new Event("click", {bubbles: true}));
        }
    }

    updateRenewalAmountDue(event) {
        console.log("I shouldn't be running updateRenewalAmountDue from bl-license-applications-controller")
    }

    updateLicensePeriods(event) {
        console.log("updating license period select")
        const formArea = event.target.closest('.bl-license-application-form')
        const selectArea = formArea.querySelector(".bl-license-application-license-period-area")
        const licenseTypeId = window.bl_license_application_license_type_id.value;
        const applicationId = formArea.querySelector("#bl_license_application_id").value ||
            formArea.querySelector("#itemReferenceId").innerText || 'new';
        if (licenseTypeId.length === 0) {
            console.log("fill in the license Type")
            formArea.querySelector(".feedback-area").innerHTML += '<p class="no-response feedback-text">License Type is missing!</p>';
        } else {
            fetch('/bl_license_applications/render_license_period_selects?license_type_id=' + licenseTypeId + "&business_license_application_id=" + applicationId)
                .then(response => {
                    return response.text();
                })
                .then(html => {
                    if (formArea.querySelector(".no-response") !== null) {
                        formArea.querySelector(".no-response").remove();
                    }
                    selectArea.innerHTML = html;
                });
        }
    }

    saveApplication(event) {
        this.persist(event.target.closest('form'));
    }

    // The Add Charge button. A units type saves the application as soon as
    // units are entered, so the button only shows once there is a record to
    // charge. A flat-fee type (project #1591) is priced with nothing entered,
    // so the click itself saves the application first and holds back the
    // miniCart action listed after it until there is an id; it then clicks
    // again with the id in place and the cart action runs as usual.
    addCharge(event) {
        if (document.getElementById("itemReferenceId").textContent.trim() !== "") {
            return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        const button = event.currentTarget;
        // Disabled while the save is in flight, so a second click cannot post
        // the form again; released before the click-through so the cart action runs.
        button.disabled = true;
        button.setAttribute("aria-busy", "true");
        this.persist(button.closest('form')).then(saved => {
            button.disabled = false;
            button.removeAttribute("aria-busy");
            if (saved) {
                button.click();
            }
        });
    }

    // Posts the form and, on success, turns it into the saved application's
    // edit form. Resolves to whether the application now has an id. A save
    // already in flight is not duplicated: the calculator's auto-save and an
    // Add Charge click can overlap, and two posts of a new form would create
    // two applications. Instead one trailing save is queued behind it and
    // re-reads the form when the flight lands, so the newest values (the
    // last units keystroke, say) are always the ones saved. Callers that
    // arrive during the flight wait for that trailing save.
    persist(form) {
        if (window.location.pathname == "/bl_license_estimators/new") {
            return Promise.resolve(false);
        }
        if (this.pendingSave) {
            this.queuedSave = this.queuedSave || this.pendingSave.then(() => {
                this.queuedSave = null;
                return this.persist(form);
            });
            return this.queuedSave;
        }
        this.pendingSave = this.post(form).finally(() => {
            this.pendingSave = null;
        });
        return this.pendingSave;
    }

    post(form) {
        const currentUnitsElement = document.getElementById('bl_license_application_current_units');
        if (currentUnitsElement) {
            const currentUnitsValue = AutoNumeric.getNumber(currentUnitsElement);
            currentUnitsElement.value = currentUnitsValue;
        }

        const unitDeductionElement = document.getElementById('bl_license_application_unit_deduction');
        if (unitDeductionElement) {
            const unitDeductionValue = AutoNumeric.getNumber(unitDeductionElement);
            unitDeductionElement.value = unitDeductionValue;
        }
        const formData = new FormData(form);
        // The test environment renders no CSRF meta tag (forgery protection is off there).
        const csrfMeta = document.querySelector('meta[name="csrf-token"]');
        const headers = {'Accept': 'application/json'};
        if (csrfMeta != null) {
            headers['X-CSRF-Token'] = csrfMeta.getAttribute('content');
        }

        return fetch(form.action, {
            method: form.method,
            body: formData,
            headers: headers
        })
            .then(response => response.json())
            .then(data => {
                showSaveErrors(form, data.errors || []);
                if (data.id) {
                    const blLicenseApplicationCreatedForm = document.querySelector(".application-form").querySelector('form');
                    const overlay = blLicenseApplicationCreatedForm.closest(".popup-form");
                    const amountDue = blLicenseApplicationCreatedForm.querySelector("#amountDue");
                    const lineItemCharge = blLicenseApplicationCreatedForm.querySelector("#lineItemCharge");
                    blLicenseApplicationCreatedForm.action = data.form_action;
                    blLicenseApplicationCreatedForm.method = "post";
                    blLicenseApplicationCreatedForm.insertAdjacentHTML('afterbegin', '<input type="hidden" name="_method" value="patch">');
                    const blaCartCreatedReference = blLicenseApplicationCreatedForm.querySelector("#itemReferenceId");
                    blaCartCreatedReference.textContent = data.id;
                    if (amountDue != null) {
                        amountDue.innerText = data.amount_outstanding;
                    }
                    if (lineItemCharge != null) {
                        lineItemCharge.innerText = data.amount_outstanding;
                    }
                    if (data.amount_outstanding > 0.0) {
                        const blaCreatedChargeButton = blLicenseApplicationCreatedForm.querySelector(".add-charge-area");
                        blaCreatedChargeButton.classList.remove("hidden");
                    }
                    document.getElementById("bl_license_application_id").value = data.id;
                    document.getElementById("bl_license_application_licensable_id").value = data.licensable_id;
                    document.getElementById("bl_license_application_licensable_type").value = data.licensable_type;
                    if (overlay != null) {
                        overlay.classList.add("editing");
                    }
                    refreshSpecificDatesEstimate(form);
                    return true;
                }
                if (!data.errors) {
                    showSaveErrors(form, [SAVE_FAILED_MESSAGE]);
                }
                return false;
            })
            .catch(error => {
                console.error('Error:', error);
                showSaveErrors(form, [SAVE_FAILED_MESSAGE]);
                return false;
            });
    }

}

// Shown when the save request fails outright (the network, or a response that
// is not the application's JSON), as opposed to a save the server refused.
const SAVE_FAILED_MESSAGE = "The application could not be saved. Please try again.";

// The reasons the server refused a save (a temporary license's dates over its
// limits, for one), shown in the form's feedback area; an empty list clears them.
function showSaveErrors(form, errors) {
    const feedbackArea = form.querySelector(".feedback-area");
    if (feedbackArea == null) {
        return;
    }
    const previous = feedbackArea.querySelector(".application-save-errors");
    if (previous != null) {
        previous.remove();
    }
    if (errors.length === 0) {
        return;
    }
    const message = document.createElement("p");
    message.className = "application-save-errors feedback-text";
    message.setAttribute("role", "alert");
    message.textContent = errors.join(". ");
    feedbackArea.appendChild(message);
}

// A temporary license (project #1592) is priced from its saved dates, so once
// they are saved the bl-license-calculator re-prices the application.
function refreshSpecificDatesEstimate(form) {
    const calculator = form.querySelector(".license-calculator");
    if (form.querySelector(".lic-specific-dates") != null && calculator != null) {
        calculator.dispatchEvent(new CustomEvent("specific-dates-saved"));
    }
}
